/**
 * Formats a date string for display
 * @param dateString - The date string to format
 * @returns Formatted date string or empty string if invalid
 */
export const formatDateStr = (dateString?: string) => {
  if (!dateString || dateString === "0001-01-01T00:00:00Z") return "";
  try {
    const date = new Date(dateString);
    const dateStr = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    });
    const timeStr = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
      hour12: false,
    });
    return `${dateStr} ${timeStr} UTC`;
  } catch (e) {
    return "";
  }
};

/**
 * Formats a date with time information
 * @param date - The date to format
 * @param includeYear - Whether to include the year in the format
 * @returns Formatted date string with time
 */
export const formatDate = (date: Date, includeYear: boolean) => {
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...(includeYear ? { year: "numeric" } : {}),
  });
};

/**
 * Formats a date for display (date only, no time)
 * @param date - The date to format
 * @returns Formatted date string (e.g., "Jan 15, 2024")
 */
export const formatDateOnly = (date: Date) => {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
